import { ON_SET_USER_INFO, ON_RESTABLECER_USER_INFO } from './Types';

export default function (state, action) {
    
    switch (action.type) {
        case ON_SET_USER_INFO:
            return {
                ...state, 
                email: action.payload.email ? action.payload.email : null, 
                tipo: action.payload.tipo ? action.payload.tipo : 1, 
                identity: action.payload.identity ? action.payload.identity : 1, 
                name: action.payload.name ? action.payload.name : null, 
                picture: action.payload.picture ? action.payload.picture : null
            };
        case ON_RESTABLECER_USER_INFO:
			return {...state, email: null, tipo: 1, identity: 1, picture: null, name: null};
        default:
            return state;
    }
}